<script>import { onMount } from "svelte";
import ContentVariants from "../../components/content-variants/index";
import { filterAttrs } from "../helpers";
import "../../components/dynamic-div.svelte";
import { getClassPropName } from "../../functions/get-class-prop-name";
import { setAttrs } from "../helpers";
import { fetchSymbolContent } from "./symbol.helpers";
export let symbol = undefined;
export let attributes = undefined;
export let dynamic = undefined;
export let builderContext;
export let builderBlock;
export let builderComponents;
export let builderLinkComponent = undefined;
function setContent() {
    if (contentToUse)
        return;
    fetchSymbolContent({
        symbol: symbol,
        builderContextValue: $builderContext,
    }).then((newContent) => {
        if (newContent) {
            contentToUse = newContent;
        }
    });
}
$: blocksWrapper = () => {
    return "div";
};
$: contentWrapper = () => {
    return "div";
};
$: className = () => {
    return [
        ...[attributes[getClassPropName()]],
        "builder-symbol",
        symbol?.inline ? "builder-inline-symbol" : undefined,
        symbol?.dynamic || dynamic ? "builder-dynamic-symbol" : undefined,
    ]
        .filter(Boolean)
        .join(" ");
};
let contentToUse = symbol?.content;
onMount(() => {
    setContent();
});
function onUpdateFn_0(..._args) {
    setContent();
}
$: onUpdateFn_0(...[symbol]);
</script>

<div
  {...filterAttrs(attributes, "on:", false)}
  {...{}}
  class={className()}
  use:setAttrs={filterAttrs(attributes, "on:", true)}
>
  <ContentVariants
    nonce={$builderContext.nonce}
    isNestedRender={true}
    apiVersion={$builderContext.apiVersion}
    apiKey={$builderContext.apiKey}
    context={{
      ...$builderContext.context,
      symbolId: builderBlock?.id,
    }}
    customComponents={Object.values(builderComponents)}
    data={{
      ...symbol?.data,
      ...$builderContext.localState,
      ...contentToUse?.data?.state,
    }}
    canTrack={$builderContext.canTrack}
    model={symbol?.model}
    content={contentToUse}
    linkComponent={builderLinkComponent}
    blocksWrapper={blocksWrapper()}
    contentWrapper={contentWrapper()}
  />
</div>